import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[420px] md:h-[600px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20dark%20newsroom%20scene%20with%20warm%20spotlight%20on%20a%20breaking%20news%20theme%2C%20Chinese%20entertainment%20media%20headquarters%20aesthetic%2C%20mysterious%20atmosphere%20with%20dark%20red%20and%20warm%20gold%20accents%2C%20professional%20photojournalism%20style%2C%20editorial%20photography%2C%20dramatic%20shadows%20and%20highlights%2C%20intense%20mood%2C%20breaking%20news%20visual&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
        alt="91黑料吃瓜网 - 最新吃瓜视频与独家黑料直击现场"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

      <div className="relative z-10 h-full w-full flex items-end">
        <div className="w-full px-4 md:px-6 pb-14 md:pb-20">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-2xl">
              <span className="inline-block px-3 py-1 text-xs font-medium text-white border border-white/40 rounded-full mb-4 whitespace-nowrap">
                每日在线更新 · 独家爆料
              </span>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight font-heading mb-3">
                最新吃瓜视频与
                <br />
                独家黑料直击现场
              </h1>
              <p className="text-sm md:text-base text-white/80 leading-relaxed mb-6 max-w-lg">
                网红博主塌房事件每日在线更新，覆盖网络红人、主播博主塌房现场，
                是您追踪内幕、了解真相的首选平台。
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <Link
                  to="/category/dujia-baoliao"
                  className="inline-flex items-center justify-center gap-2 px-5 py-2.5 bg-primary-500 text-white rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  查看独家爆料
                  <i className="ri-arrow-right-line"></i>
                </Link>
                <Link
                  to="/category/wanghong-tafang"
                  className="inline-flex items-center justify-center gap-2 px-5 py-2.5 border border-white/50 text-white rounded-md text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
                >
                  最新塌房现场
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}